import utcToZonedTime from 'date-fns-tz/utcToZonedTime';
import parseISO from 'date-fns/parseISO';
import defaultTimezone from 'Common/constants/defaultTimezone';

const parseDate = date => utcToZonedTime(parseISO(date), defaultTimezone);

export default parseDate;
